export default __webpack_public_path__ + "static/media/dolphins.06b2750a.png";